/**
 * Shared constants + helpers for the Old Gold Recovery module.
 */

export const STATUS_COLOURS = {
  in_stock: 'bg-emerald-100 text-emerald-800',
  issued:   'bg-amber-100  text-amber-800',
  broken:   'bg-gray-200   text-gray-700',
  open:     'bg-amber-100  text-amber-800',
  completed:'bg-emerald-100 text-emerald-800',
};

export const CATEGORY_LABEL = {
  diamond: 'Diamond',
  stone: 'Stone',
  beads_pearl: 'Beads & Pearls',
  dust: 'Dust',
  others: 'Others',
};

// Categories where MIA/receiver must enter piece counts + usability.
export const INSERT_CATEGORIES = ['diamond', 'stone', 'beads_pearl'];
// Weight-only categories — no pcs, no usability. Always allowed at breakage
// regardless of what receipt declared.
export const WEIGHT_ONLY_CATEGORIES = ['dust', 'others'];
export const ALL_CATEGORIES = [...INSERT_CATEGORIES, ...WEIGHT_ONLY_CATEGORIES];
export const isWeightOnly = (cat) => WEIGHT_ONLY_CATEGORIES.includes(cat);

export const num = (v) => (Number.isFinite(+v) ? +v : 0);
export const fmt = (v, d = 3) => (num(v)).toFixed(d);
